import { useContext, useEffect, useRef } from 'react';

import { AppContext } from '../../../capabilities/contextStore/AppContext';
import { NotificationContext } from '../../../capabilities/contextStore/NotificationContext';
import useRoutingHelper from '../../../hooks/useRoutingHelper/useRoutingHelper';

const useShowAddPaymentMethodWarning = () => {
  const { addPaymentMethodWarning, setData } =
    useContext(AppContext);
  const { notify } = useContext(NotificationContext);
  const { params } = useRoutingHelper();

  const prevParamsSecondary = useRef<string | undefined>(undefined);
  const currentParamsSecondary = params?.secondary;
  const parentRoute = params?.parentRoute;

  useEffect(() => {
    if (
      addPaymentMethodWarning &&
      ((currentParamsSecondary === undefined &&
        prevParamsSecondary.current === 'secondary') ||
        (!prevParamsSecondary.current &&
          !currentParamsSecondary) ||
        params?.['*'] === 'wallet-management')
    ) {
      notify({
        title: addPaymentMethodWarning.title,
        message: addPaymentMethodWarning.description,
        severity: 'warning',
      });

      setData({ addPaymentMethodWarning: undefined });
    }
    prevParamsSecondary.current = currentParamsSecondary;
  }, [
    addPaymentMethodWarning,
    currentParamsSecondary,
    parentRoute,
  ]);
};

export default useShowAddPaymentMethodWarning;
